

const InputLoading = ({
    label = '',
    isRequired = true
}: IPropLoading) => {

    return (
        <>
            <div className="lbl-input-auto-cr mt-10 mb-5" style={{ display: "flex" }}>
                <span> {label} {isRequired && <span style={{ color: '#FF5F49' }}>*</span>} </span>
            </div>
            <div className="input-fiel-loading mb-20">
                <label>Cargando....</label>
            </div>
        </>
    )

}

export { InputLoading };